import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-url"]

import { ref } from 'vue'
import { useCookies } from "@vueuse/integrations/useCookies";

const calendlyScriptSrc = "https://assets.calendly.com/assets/external/widget.js"


export default /*#__PURE__*/_defineComponent({
  __name: 'CalendlyEmbed',
  setup(__props) {

const calendlyUrl = ref<string>("https://calendly.com/taylor-augmentify/30min?hide_gdpr_banner=1")
const calendlyAnswers : { [index : string] : string } = {
  name: 'name',
  email: 'email',
  company: 'a1'
}

const cookies = useCookies()
const user = cookies.get('user')

Object.keys(user).forEach((prop: string) => {
  if(user[prop]) {
    calendlyUrl.value += (`&${calendlyAnswers[prop]}=${user[prop].replaceAll(' ', '%20')}`)
  }
})

const calendlyScript = document.createElement("script")

calendlyScript.setAttribute("src", calendlyScriptSrc)
calendlyScript.setAttribute("async", "true")

document.head.appendChild(calendlyScript)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "calendly-inline-widget",
    "data-url": calendlyUrl.value,
    style: {"min-width":"320px","height":"700px"}
  }, null, 8, _hoisted_1))
}
}

})